import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { Camera } from 'src/models/Camera.model';
import { CameraMode } from 'src/models/CameraMode.model';

import useUiTranslation from 'src/hooks/useUiTranslation';

import CameraLanguageDropdown from './CameraLanguageDropdown';

const PatientInfoWithControls = () => {
  const {
    cameraData,
    cameraMode,
    practiceSettings: { camera },
    session,
  } = useRemoteBoundStore();

  const { tCommon } = useUiTranslation();

  return (
    <div className="d-flex justify-content-between mb-2">
      <div>
        <h6 className="text-primary">
          {tCommon('patientFields.patientID')}: {session.id}
        </h6>
        <h3 className="fw-bold">
          {session.firstName} {session.lastName}
        </h3>
      </div>

      {camera === Camera.SMALL &&
        cameraMode === CameraMode.API &&
        cameraData && <CameraLanguageDropdown />}
    </div>
  );
};

export default PatientInfoWithControls;
